import { FileText, ChevronRight } from 'lucide-react';

interface TOCItem {
  id: string;
  label: string;
  page?: number;
}

interface TableOfContentsProps {
  items: TOCItem[];
}

const TableOfContents = ({ items }: TableOfContentsProps) => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="bg-zinc-900/50 border border-zinc-800 p-6 rounded-lg animate-slide-up">
      <div className="flex items-center gap-3 mb-4">
        <FileText className="w-5 h-5 text-green-500" />
        <h3 className="text-lg font-semibold text-white">Table of Contents</h3>
      </div>

      <nav className="space-y-1">
        {items.map((item, index) => (
          <button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-zinc-800/50 transition-colors text-left group border border-transparent hover:border-zinc-700"
          >
            <span className="text-zinc-400 text-sm font-mono w-6">
              {String(index + 1).padStart(2, '0')}
            </span>
            <span className="flex-1 font-medium text-white group-hover:text-green-400 transition-colors">
              {item.label}
            </span>
            <ChevronRight className="w-4 h-4 text-zinc-400 group-hover:text-green-400 transition-colors" />
          </button>
        ))}
      </nav>
    </div>
  );
};

export default TableOfContents;
